import { callProvince } from "../../../../components/address/address.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField } from "../../../../utils/form";

export const callDocumentStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DOCUMENT_STATUS", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.storageLocation.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.storageLocation.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.storageLocation.isLocation"), dataIndex: "name" }),
        createColumnSelect({
            title: () => i18n.global.t("views.request.storageLocation.province"),
            dataIndex: "addresses.refProvince.nameTh",
            dataIndexValue: ({ record }) => record?.addresses?.[0]?.refProvince?.nameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callProvince, optLabel: "nameTh" }),
            search: { name: "addresses.refProvince.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.storageLocation.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "addresses.refProvince.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
